import React from 'react';
import { cn } from '../../utils/cn';
interface StatusToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  activeLabel?: string;
  inactiveLabel?: string;
  disabled?: boolean;
  size?: 'sm' | 'md';
}
export function StatusToggle({
  checked,
  onChange,
  activeLabel = 'Active',
  inactiveLabel = 'Inactive',
  disabled = false,
  size = 'sm'
}: StatusToggleProps) {
  const handleToggle = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleToggle();
    }
  };
  return <div className="flex items-center gap-2.5" data-id="element-302">
      <button type="button" role="switch" aria-checked={checked} aria-label={checked ? activeLabel : inactiveLabel} tabIndex={0} onClick={handleToggle} onKeyDown={handleKeyDown} disabled={disabled} className={cn('relative inline-flex items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2', size === 'sm' ? 'h-5 w-9' : 'h-6 w-11', checked ? 'bg-primary-600' : 'bg-slate-300', disabled && 'opacity-50 cursor-not-allowed', !disabled && 'cursor-pointer')} data-id="element-303">
        <span className={cn('inline-block rounded-full bg-white shadow-sm transform transition-transform duration-200 ease-in-out', size === 'sm' ? 'h-3.5 w-3.5' : 'h-4.5 w-4.5', size === 'sm' ? checked ? 'translate-x-[18px]' : 'translate-x-[3px]' : checked ? 'translate-x-[22px]' : 'translate-x-[3px]')} data-id="element-304" />
      </button>
      <span className={cn('text-xs font-medium select-none', checked ? 'text-primary-700' : 'text-slate-500')} data-id="element-305">
        {checked ? activeLabel : inactiveLabel}
      </span>
    </div>;
}